import React from 'react';
export function CopyIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8a1 1 0 100-2H18V5a3 3 0 00-3-3H5a3 3 0 00-3 3v10a3 3 0 003 3h1v.5a1 1 0 102 0V18h7a3 3 0 003-3V8h.5zM16 15a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v10zM10.9 20H9c-.145 0-.288-.031-.419-.091a1.001 1.001 0 00-1.38 1.254 1 1 0 00.542.56c.394.183.823.277 1.257.277h1.9a1 1 0 000-2zM21.719 7.73a1 1 0 00-1.813.846A1 1 0 0120 9v1.89a1 1 0 102 0V9c0-.44-.095-.873-.281-1.27zM16.429 20h-2.764a1 1 0 000 2h2.764a1 1 0 100-2zM21 12.655a1 1 0 00-1 1v2.765a1 1 0 002 0v-2.765a1 1 0 00-1-1zM21.083 18.188a1 1 0 00-1.083.905 1 1 0 01-.9.9 1 1 0 10.094 2h.1a3 3 0 002.7-2.71 1.001 1.001 0 00-.911-1.095z"
  }));
}